import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import { RevenueHistoriesForMonth } from 'src/lib/entity/revenue'
import { ConsoleLogger } from 'src/lib/console-logger'
import { Subscription } from 'rxjs'

@Component({
  selector: 'maglive-revenue-detail',
  templateUrl: './revenue-detail.component.html',
  styleUrls: ['./revenue-detail.component.scss'],
})
export class RevenueDetailComponent implements OnInit, OnDestroy {
  revenueHistory: RevenueHistoriesForMonth | 'NOT_FOUND'

  /* Subscription */
  private getRevenueHistoriesForMonthSub: Subscription | undefined

  @Input() yearMonth: string
  @Input() selectedMagazineId: number

  constructor(private logger: ConsoleLogger) {}

  ngOnInit(): void {
    this.logger.info(
      this.constructor.name,
      'ngOnInit',
      'yearMonth',
      this.yearMonth
    )
    this.logger.info(
      this.constructor.name,
      'ngOnInit',
      'selectedMagazineId',
      this.selectedMagazineId
    )
    let [year, month] = this.yearMonth.split('年')
    month = month.split('月')[0]
    this.getRevenueHistoriesForMonthSub =
      MagliveApiClient.getRevenueHistoriesForMonth(
        this.selectedMagazineId,
        year + '-' + month
      ).subscribe((value) => {
        if (value !== 'NOT_FOUND') {
          this.revenueHistory = value
          if (!this.revenueHistory.items) this.revenueHistory = 'NOT_FOUND'
        }
        this.logger.info(
          this.constructor.name,
          'getRevenueHistoriesForMonth',
          'revenueHistory',
          this.revenueHistory
        )
      })
  }

  ngOnDestroy(): void {
    if (this.getRevenueHistoriesForMonthSub) {
      this.getRevenueHistoriesForMonthSub.unsubscribe()
    }
  }
}
